import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel"
};
const _hoisted_2 = {
  class: "flex flex-wrap items-center gap-1 rounded-lg bg-slate-100 p-1"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_5 = ["disabled"];
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
  class: "bg-white rounded-xl shadow-sm border border-slate-200 p-4 mb-4 hidden"
};
const _hoisted_8 = {
  class: "flex items-center justify-between gap-4 flex-wrap"
};
const _hoisted_9 = {
  class: "flex items-center gap-1 bg-slate-100 p-1 rounded-lg"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "flex items-center gap-3"
};
const _hoisted_12 = {
  class: "relative"
};
const _hoisted_13 = {
  class: "bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden"
};
const _hoisted_14 = {
  key: 0,
  class: "divide-y divide-slate-100"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "flex items-start gap-4"
};
const _hoisted_17 = {
  key: 0,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
};
const _hoisted_18 = {
  key: 1,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
};
const _hoisted_19 = {
  key: 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
};
const _hoisted_20 = {
  class: "flex-1 min-w-0"
};
const _hoisted_21 = {
  class: "flex items-start justify-between gap-4"
};
const _hoisted_22 = {
  class: "min-w-0"
};
const _hoisted_23 = {
  class: "flex items-center gap-2"
};
const _hoisted_24 = {
  class: "font-medium text-slate-800 truncate"
};
const _hoisted_25 = {
  key: 0,
  class: "status-badge bg-primary-100 text-primary-700 flex-shrink-0"
};
const _hoisted_26 = {
  class: "text-sm text-slate-600 mt-1 line-clamp-2"
};
const _hoisted_27 = {
  class: "text-xs text-slate-400 mt-2"
};
const _hoisted_28 = {
  class: "flex items-center gap-2 flex-shrink-0"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["onClick"];
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  key: 1,
  class: "py-16 text-center"
};
const _hoisted_33 = {
  class: "text-slate-500 mb-2"
};
const _hoisted_34 = {
  key: 0,
  class: "text-sm text-slate-400"
};
import { ref, computed, onMounted, watch } from 'vue';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import MessageDetailModal from '@/components/MessageDetailModal.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { getNotifications, deleteUserNotification } from '@/api/notification';
import { stripHtmlTags } from '@/utils/htmlContent';
import { useMessageStore, typeMap, formatTime } from '@/composables/useMessageStore';
import { useNotificationNavigation } from '@/composables/useNotificationNavigation';
export default {
  __name: 'MessageCenter',
  setup(__props) {
    const router = useRouter();
    const {
      hasNotificationNavigation,
      navigateNotification
    } = useNotificationNavigation(router);
    const {
      unreadCount,
      markAsRead: storeMarkAsRead,
      markAllRead: storeMarkAllRead,
      deleteMessage
    } = useMessageStore();
    const activeTab = ref('all');
    const searchKeyword = ref('');
    const currentPage = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    const loading = ref(false);
    const showDetailModal = ref(false);
    const currentMessage = ref(null);
    const messageList = ref([]);

    // 加载消息列表
    async function loadMessages() {
      try {
        loading.value = true;
        const params = {
          pageNum: currentPage.value,
          pageSize: pageSize.value
        };

        // 处理类型筛选
        if (activeTab.value === 'approval') {
          params.type = 'APPROVAL,TASK';
        } else if (activeTab.value === 'system') {
          params.type = 'SYSTEM';
        }
        const res = await getNotifications(params);
        messageList.value = (res.records || []).map(item => ({
          id: item.id,
          type: typeMap[item.type] || 'system',
          title: item.title,
          content: item.summary || stripHtmlTags(item.content),
          contentHtml: item.content || '',
          time: formatTime(item.createTime),
          isRead: item.read,
          readTime: item.readTime,
          bizType: item.bizType,
          linkType: item.linkType,
          businessId: item.businessId,
          webUrl: item.webUrl,
          webPath: item.webPath,
          webNewWindow: item.webNewWindow,
          extraParams: item.extraParams
        }));
        total.value = res.total || 0;
      } catch (error) {
        console.error('加载消息列表失败:', error);
        ElMessage.error(error.message || '加载消息列表失败');
      } finally {
        loading.value = false;
      }
    }

    // 全部消息
    const tabs = computed(() => [{
      value: 'all',
      label: '全部',
      count: unreadCount.value > 0 ? `${unreadCount.value}+` : ''
    }, {
      value: 'approval',
      label: '审批'
    }, {
      value: 'system',
      label: '系统'
    }]);

    // 过滤后的消息
    const filteredMessages = computed(() => {
      let result = messageList.value;

      // 按标签筛选
      if (activeTab.value === 'approval') {
        result = result.filter(m => m.type === 'approval');
      } else if (activeTab.value === 'system') {
        result = result.filter(m => m.type === 'system');
      }

      // 按关键词搜索
      if (searchKeyword.value) {
        const keyword = searchKeyword.value.toLowerCase();
        result = result.filter(m => m.title.toLowerCase().includes(keyword) || m.content.toLowerCase().includes(keyword));
      }
      return result;
    });
    const totalCount = computed(() => filteredMessages.value.length);
    function getMessageIconBg(type) {
      const bgMap = {
        approval: 'bg-amber-100',
        system: 'bg-blue-100'
      };
      return bgMap[type] || 'bg-slate-100';
    }
    function getMessageIconColor(type) {
      const colorMap = {
        approval: 'text-amber-600',
        system: 'text-blue-600'
      };
      return colorMap[type] || 'text-slate-600';
    }
    function getTypeLabel(type) {
      const labelMap = {
        approval: '审批',
        system: '系统'
      };
      return labelMap[type] || '消息';
    }
    function getTypeLabelClass(type) {
      const classMap = {
        approval: 'status-badge is-warning',
        system: 'status-badge is-info'
      };
      return classMap[type] || 'status-badge is-neutral';
    }

    // 标记全部已读
    function handleSearch() {
      currentPage.value = 1;
      loadMessages();
    }
    function handleReset() {
      searchKeyword.value = '';
      currentPage.value = 1;
      loadMessages();
    }
    function handleRefresh() {
      loadMessages();
    }
    async function handleMarkAllRead() {
      try {
        await storeMarkAllRead();
        ElMessage.success('已全部标记为已读');
        await loadMessages();
      } catch (error) {
        console.error('标记全部已读失败:', error);
        ElMessage.error(error.message || '操作失败');
      }
    }

    // 标记单条已读
    async function handleMarkAsRead(msg) {
      if (msg.isRead) return;
      try {
        await storeMarkAsRead(msg.id);
        msg.isRead = true;
      } catch (error) {
        console.error('标记已读失败:', error);
      }
    }

    // 删除消息
    async function handleDeleteMessage(msg) {
      try {
        await deleteUserNotification(msg.id);
        // 从本地列表移除
        const index = messageList.value.findIndex(m => m.id === msg.id);
        if (index > -1) {
          messageList.value.splice(index, 1);
        }
        // 同步更新全局状态
        deleteMessage(msg.id);
        ElMessage.success('删除成功');
      } catch (error) {
        console.error('删除消息失败:', error);
        ElMessage.error(error.message || '删除失败');
      }
    }

    // 点击跳转按钮
    async function handleNavigationClick(msg) {
      // 如果未读，先标记已读
      if (!msg.isRead) {
        await handleMarkAsRead(msg);
      }
      // 执行跳转
      navigateNotification(msg);
    }
    async function handleDetailNavigation(msg) {
      showDetailModal.value = false;
      await handleNavigationClick(msg);
    }

    // 点击消息（只标记已读和显示详情，不跳转）
    async function handleMessageClick(msg) {
      // 标记已读
      await handleMarkAsRead(msg);

      // 如果有富文本内容，显示详情弹窗
      if (msg.contentHtml) {
        currentMessage.value = msg;
        showDetailModal.value = true;
      }
    }

    // 标记是否正在切换标签
    let isTabChanging = false;
    const handlePageChange = page => {
      currentPage.value = page;
    };
    const handlePageSizeChange = size => {
      pageSize.value = size;
      currentPage.value = 1;
    };

    // 监听页码变化
    watch(currentPage, oldPage => {
      // 避免首次加载时重复触发（oldPage 为 undefined 是 Vue 初始化）
      // 避免与 activeTab 重置页码时重复触发
      if (oldPage !== undefined && oldPage !== null && !isTabChanging) {
        loadMessages();
      }
      isTabChanging = false;
    });

    // 监听标签切换
    watch(activeTab, () => {
      isTabChanging = true;
      currentPage.value = 1;
      loadMessages();
    });

    // 监听搜索关键词变化（防抖）
    let searchTimeout;
    watch(searchKeyword, () => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        loadMessages();
      }, 300);
    });
    onMounted(() => {
      loadMessages();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(ListPageShell, null, {
        header: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "消息中心"), _createElementVNode("p", {
          class: "list-page-description"
        }, "查看和管理您的所有消息通知")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: handleRefresh
        }, {
          actions: _withCtx(() => [_unref(unreadCount) > 0 ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn-outline-primary inline-flex items-center gap-2",
            onClick: handleMarkAllRead
          }, [...(_cache[5] || (_cache[5] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1), _createTextVNode(" 全部已读 ", -1)]))])) : _createCommentVNode("", true)]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: loading.value,
            onClick: handleSearch
          }, " 搜索 ", 8, _hoisted_5), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: loading.value,
            onClick: handleReset
          }, " 重置 ", 8, _hoisted_6)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, tab => {
            return _openBlock(), _createElementBlock("button", {
              key: tab.value,
              class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer", activeTab.value === tab.value ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-600 hover:text-slate-800']),
              onClick: $event => activeTab.value = tab.value
            }, [_createTextVNode(_toDisplayString(tab.label) + " ", 1), tab.count && tab.count !== '' ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["status-badge ml-1.5", activeTab.value === tab.value ? 'bg-primary-100 text-primary-700' : 'bg-slate-200 text-slate-600'])
            }, _toDisplayString(tab.count), 3)) : _createCommentVNode("", true)], 10, _hoisted_3);
          }), 128))]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
            type: "text",
            placeholder: "搜索消息...",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, searchKeyword.value]]), _cache[4] || (_cache[4] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, tab => {
          return _openBlock(), _createElementBlock("button", {
            key: tab.value,
            class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer", activeTab.value === tab.value ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-600 hover:text-slate-800']),
            onClick: $event => activeTab.value = tab.value
          }, [_createTextVNode(_toDisplayString(tab.label) + " ", 1), tab.count && tab.count !== '' ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["status-badge ml-1.5", activeTab.value === tab.value ? 'bg-primary-100 text-primary-700' : 'bg-slate-200 text-slate-600'])
          }, _toDisplayString(tab.count), 3)) : _createCommentVNode("", true)], 10, _hoisted_10);
        }), 128))]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[6] || (_cache[6] = _createElementVNode("svg", {
          class: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        })], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchKeyword.value = $event),
          type: "text",
          placeholder: "搜索消息...",
          class: "pl-10 pr-4 py-2 w-64 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        }, null, 512), [[_vModelText, searchKeyword.value]])]), _unref(unreadCount) > 0 ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "flex items-center gap-2 px-4 py-2 text-sm font-medium text-primary-600 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors cursor-pointer",
          onClick: handleMarkAllRead
        }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 13l4 4L19 7"
        })], -1), _createTextVNode(" 全部已读 ", -1)]))])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_13, [filteredMessages.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMessages.value, msg => {
          return _openBlock(), _createElementBlock("div", {
            key: msg.id,
            class: _normalizeClass(["p-4 hover:bg-slate-50 transition-colors cursor-pointer", {
              'bg-blue-50/50': !msg.isRead
            }]),
            onClick: $event => handleMessageClick(msg)
          }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
            class: _normalizeClass(["w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0", getMessageIconBg(msg.type)])
          }, [(_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["w-5 h-5", getMessageIconColor(msg.type)]),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [msg.type === 'approval' ? (_openBlock(), _createElementBlock("path", _hoisted_17)) : msg.type === 'system' ? (_openBlock(), _createElementBlock("path", _hoisted_18)) : (_openBlock(), _createElementBlock("path", _hoisted_19))], 2))], 2), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("p", _hoisted_24, _toDisplayString(msg.title), 1), _createElementVNode("span", {
            class: _normalizeClass(["status-badge flex-shrink-0", getTypeLabelClass(msg.type)])
          }, _toDisplayString(getTypeLabel(msg.type)), 3), !msg.isRead ? (_openBlock(), _createElementBlock("span", _hoisted_25, "未读")) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_26, _toDisplayString(msg.content), 1), _createElementVNode("p", _hoisted_27, _toDisplayString(msg.time), 1)]), _createElementVNode("div", _hoisted_28, [_unref(hasNotificationNavigation)(msg) ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "flex items-center gap-1 text-xs text-primary-600 hover:text-primary-700 px-2 py-1 rounded hover:bg-primary-50 transition-colors cursor-pointer",
            onClick: _withModifiers($event => handleNavigationClick(msg), ["stop"])
          }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
          })], -1), _createTextVNode(" 查看 ", -1)]))], 8, _hoisted_29)) : _createCommentVNode("", true), !msg.isRead ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "text-xs text-slate-500 hover:text-primary-600 px-2 py-1 rounded hover:bg-primary-50 transition-colors cursor-pointer",
            onClick: _withModifiers($event => handleMarkAsRead(msg), ["stop"])
          }, " 标记已读 ", 8, _hoisted_30)) : _createCommentVNode("", true), _createElementVNode("button", {
            class: "text-xs text-slate-400 hover:text-slate-600 px-2 py-1 rounded hover:bg-slate-100 transition-colors cursor-pointer",
            onClick: _withModifiers($event => handleDeleteMessage(msg), ["stop"])
          }, " 删除 ", 8, _hoisted_31)])])])])], 10, _hoisted_15);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_32, [_cache[9] || (_cache[9] = _createElementVNode("svg", {
          class: "w-16 h-16 mx-auto text-slate-300 mb-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
        })], -1)), _createElementVNode("p", _hoisted_33, _toDisplayString(searchKeyword.value ? '没有找到相关消息' : '暂无消息'), 1), searchKeyword.value ? (_openBlock(), _createElementBlock("p", _hoisted_34, "试试其他关键词")) : _createCommentVNode("", true)])), totalCount.value > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 2,
          class: "pagination-bridge",
          current: currentPage.value,
          size: pageSize.value,
          total: totalCount.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["current", "size", "total"])) : _createCommentVNode("", true)])])]),
        _: 1
      }), _createVNode(MessageDetailModal, {
        modelValue: showDetailModal.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => showDetailModal.value = $event),
        message: currentMessage.value,
        "show-navigation": currentMessage.value && _unref(hasNotificationNavigation)(currentMessage.value),
        onNavigate: handleDetailNavigation
      }, null, 8, ["modelValue", "message", "show-navigation"])], 64);
    };
  }
};